import type { Lang } from '../../lib/i18n';
import { plannerStrings } from '../../lib/tools';
import { EmbedLayout } from '../../components/tools/ToolParts';
import { CompetitionPlanner, PLANNER_SLUG } from '../../components/tools/CompetitionPlanner';

export default function CompetitionPlannerEmbed({ lang = 'en' as Lang }: { lang?: Lang }) {
  const t = plannerStrings(lang);
  return (
    <EmbedLayout lang={lang} slug={PLANNER_SLUG} title={t.embed.frameTitle} credit={t.embed.credit}>
      <CompetitionPlanner lang={lang} embed />
    </EmbedLayout>
  );
}
